<template>
<div id="enter-title"> 
    <single-line-text-editor ref="singleLineText" :text="titleInternal" :optional="optional" textAreaId="rv-entryTitle" 
                textInputWrapperClass="inputContainer" :createTextWithSize="false"
                :config="textCanvasConfig" :label="this.$t('railwayStepOneHint').toString()"
                @change="updateTitle" @changeInternal="updateInternalTitle"></single-line-text-editor>
    <primary-buttons @confirm="onConfirm" @cancel="onCancel" :confirmable="confirmable"></primary-buttons>
</div>
</template>

<script type="ts">
import { Module, VuexModule, getModule } from 'vuex-module-decorators'
import { Component, Vue, Prop } from 'vue-property-decorator'
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import { AppModule } from '@/store/modules/app'
import { RailwayModule } from '@/store/modules/railway'
import SingleLineTextEditor from '@/components/products/railway/design/SingleLineTextEditorImpl.vue'
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'
import { ErrorsModule } from '@/store/modules/error'

export default {
    title: 'enter-title',
    props: {
        optional: Boolean
    },
    data: function() {
        return {
            titleOriginal: "",
            userInputTitleOriginal: "",
            mounted: false,
        }
    },
    created: function() {
        this.titleOriginal = RailwayModule.title
        this.userInputTitleOriginal = RailwayModule.userInputTitle
    },
    mounted: function() {
        this.mounted = true
    },
    computed: {
        confirmable: function() {
            if(this.mounted) {
                return this.$refs.singleLineText.validate()
            }
            return false
        },
        titleInternal: function() {
            return RailwayModule.userInputTitle
        },
        textCanvasConfig: function() {
            return AppModule.textConfig
        },
        hasForbiddenChars: function() {
            return ErrorsModule.keys.includes('forbiddenCharacters')
        },
        hasInvalidChars: function() {
            return ErrorsModule.keys.includes('invalidCharacters')
        }
    },
    methods: {
        onCancel: function() {
            RailwayModule.SetTitle(this.titleOriginal)
            RailwayModule.SetUserInputTitle(this.userInputTitleOriginal)
            if (this.hasForbiddenChars) {
                let forbiddeneError = { key: 'forbiddenCharacters' }
                ErrorsModule.SetError(forbiddeneError)
            }
            if (this.hasInvalidChars) {
                let invalidError = { key: 'invalidCharacters' }
                ErrorsModule.SetError(invalidError)
            }
            this.$emit('cancel')
        },
        onConfirm: function() {
            if(this.$refs.singleLineText.validate()) {
                this.$emit('confirm')
            }
        },
        goToMenu: function() {
            if(this.confirmable) {
                this.onConfirm()
            }else {
                this.onCancel()
            }
        },
        updateTitle: function(newValue) {
            RailwayModule.SetTitle(newValue.trim())
        },
        updateInternalTitle: function(newValue) {
            RailwayModule.SetUserInputTitle(newValue)
        },
    },
    components: {
        PrimaryButtons, SingleLineTextEditor
    }
}
</script>


<style lang="scss">
#enter-title{
    
    .inputContainer{
        height: 387px;

         @media (max-width: $rv-doubleTeaserBreakpoint) {
            height:initial;
        }
        input:focus{
            outline: none;
            border-color:#80bdff;
            box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.25);

        }
    }
}
</style>